webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(201);


/***/ },

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(74);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileView = function FileView(props) {
	  var file = props.file,
	      fileClickHandler = props.fileClickHandler,
	      selectedFilePath = props.selectedFilePath,
	      fileTemplate = props.fileTemplate;
	
	
	  var fileClassName = (props.fileClassName || '') + ' item';
	  var selectedClassName = props.selectedClassName || 'active';
	  var cns = selectedFilePath === file.path ? selectedClassName + ' ' + fileClassName : fileClassName;
	  var onclickFn = function onclickFn() {
	    fileClickHandler && fileClickHandler(file);
	  };
	
	  return _react2.default.createElement(
	    'li',
	    {
	      key: 'file-' + file.path,
	      className: cns,
	      onClick: onclickFn },
	    fileTemplate && fileTemplate({ name: file.name }) || _react2.default.createElement(
	      'a',
	      null,
	      '|__',
	      file.name
	    )
	  );
	};
	
	exports.default = FileView;

/***/ },

/***/ 200:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '_contents': [{
	    'name': '.gitignore',
	    'path': '.gitignore'
	  }, {
	    'name': 'README.md',
	    'path': 'README.md'
	  }, {
	    'name': 'Yo Ted',
	    'path': 'Yo Ted'
	  }, {
	    'name': 'getCustomer.png',
	    'path': 'getCustomer.png'
	  }, {
	    'name': 'index.html',
	    'path': 'index.html'
	  }],
	  '_layouts': {
	    '_contents': [{
	      'name': '2016-9-10-new-file.md',
	      'path': '_layouts/2016-9-10-new-file.md'
	    }]
	  },
	  '_posts': {
	    '_contents': [{
	      'name': 'new-fil-654679.md',
	      'path': '_posts/new-fil-654679.md'
	    }, {
	      'name': 'new-file1473154764527.md',
	      'path': '_posts/new-file1473154764527.md'
	    }, {
	      'name': 'new-file1473156139761.md',
	      'path': '_posts/new-file1473156139761.md'
	    }]
	  },
	  '_sass': {
	    '_contents': [],
	    'bourbon': {
	      '_contents': [{
	        'name': 'LICENSE.md',
	        'path': '_sass/bourbon/LICENSE.md'
	      }, {
	        'name': 'README.md',
	        'path': '_sass/bourbon/README.md'
	      }, {
	        'name': 'bower.json',
	        'path': '_sass/bourbon/bower.json'
	      }, {
	        'name': 'eyeglass-exports.js',
	        'path': '_sass/bourbon/eyeglass-exports.js'
	      }, {
	        'name': 'index.js',
	        'path': '_sass/bourbon/index.js'
	      }],
	      'app': {
	        '_contents': [],
	        'assets': {
	          '_contents': [],
	          'stylesheets': {
	            '_contents': [{
	              'name': '_bourbon-deprecated-upcoming.scss',
	              'path': '_sass/bourbon/app/assets/stylesheets/_bourbon-deprecated-upcoming.scss'
	            }, {
	              'name': '_bourbon.scss',
	              'path': '_sass/bourbon/app/assets/stylesheets/_bourbon.scss'
	            }],
	            'addons': {
	              '_contents': [{
	                'name': '_border-color.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/addons/_border-color.scss'
	              }, {
	                'name': '_word-wrap.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/addons/_word-wrap.scss'
	              }]
	            },
	            'css3': {
	              '_contents': [{
	                'name': '_animation.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/css3/_animation.scss'
	              }, {
	                'name': '_appearance.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/css3/_appearance.scss'
	              }, {
	                'name': '_transition.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/css3/_transition.scss'
	              }, {
	                'name': '_user-select.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/css3/_user-select.scss'
	              }]
	            },
	            'functions': {
	              '_contents': [{
	                'name': '_assign-inputs.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/functions/_assign-inputs.scss'
	              }, {
	                'name': '_contains-falsy.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/functions/_contains-falsy.scss'
	              }, {
	                'name': '_unpack.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/functions/_unpack.scss'
	              }]
	            },
	            'helpers': {
	              '_contents': [{
	                'name': '_convert-units.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/helpers/_convert-units.scss'
	              }, {
	                'name': '_directional-values.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/helpers/_directional-values.scss'
	              }, {
	                'name': '_str-to-num.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/helpers/_str-to-num.scss'
	              }]
	            },
	            'settings': {
	              '_contents': [{
	                'name': '_asset-pipeline.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/settings/_asset-pipeline.scss'
	              }, {
	                'name': '_prefixer.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/settings/_prefixer.scss'
	              }, {
	                'name': '_px-to-em.scss',
	                'path': '_sass/bourbon/app/assets/stylesheets/settings/_px-to-em.scss'
	              }]
	            }
	          }
	        }
	      }
	    },
	    'website': {
	      '_contents': [{
	        'name': 'main.scss',
	        'path': '_sass/website/main.scss'
	      }],
	      'partials': {
	        '_contents': [{
	          'name': 'README.md',
	          'path': '_sass/website/partials/README.md'
	        }, {
	          'name': '_notifications.scss',
	          'path': '_sass/website/partials/_notifications.scss'
	        }, {
	          'name': '_top.scss',
	          'path': '_sass/website/partials/_top.scss'
	        }]
	      }
	    }
	  }
	};

/***/ },

/***/ 201:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(74);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(175);
	
	var _NestedFileTreeView = __webpack_require__(203);
	
	var _NestedFileTreeView2 = _interopRequireDefault(_NestedFileTreeView);
	
	var _directory = __webpack_require__(200);
	
	var _directory2 = _interopRequireDefault(_directory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Shims and polyfills.
	__webpack_require__(170);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(140);
	
	__webpack_require__(485);
	
	var Demo1 = function (_Component) {
	  _inherits(Demo1, _Component);
	
	  function Demo1(props) {
	    _classCallCheck(this, Demo1);
	
	    var _this = _possibleConstructorReturn(this, (Demo1.__proto__ || Object.getPrototypeOf(Demo1)).call(this, props));
	
	    _this.state = {
	      selectedFile: '.gitignore'
	    };
	    return _this;
	  }
	
	  _createClass(Demo1, [{
	    key: 'handleFileClick',
	    value: function handleFileClick(file) {
	      console.log(file);
	      this.setState({ selectedFile: file.path });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_NestedFileTreeView2.default, {
	        selectedFilePath: this.state.selectedFile,
	        fileClickHandler: this.handleFileClick.bind(this),
	        directory: _directory2.default });
	    }
	  }]);
	
	  return Demo1;
	}(_react.Component);
	
	function Demo2() {
	  return _react2.default.createElement(_NestedFileTreeView2.default, {
	    expended: true,
	    maxFolderLevel: 3,
	    directory: _directory2.default });
	}
	
	function Demo3() {
	  return _react2.default.createElement(_NestedFileTreeView2.default, {
	    expended: true,
	    maxFolderLevel: 3,
	    fileTemplate: CustomFile,
	    folderTemplate: CustomFolder,
	    directory: _directory2.default });
	}
	
	function CustomFolder(props) {
	  return _react2.default.createElement(
	    'a',
	    { onClick: props.onclick },
	    _react2.default.createElement('span', { className: 'svg',
	      dangerouslySetInnerHTML: { __html: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" baseProfile="full" width="24" height="24" viewBox="0 0 24.00 24.00" enable-background="new 0 0 24.00 24.00" xml:space="preserve">' + '<path d="M0 0h24v24H0z" fill="none"></path>' + '<path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"></path>' + '</svg>' } }),
	    props.name
	  );
	}
	
	function CustomFile(props) {
	  return _react2.default.createElement(
	    'a',
	    null,
	    _react2.default.createElement('span', { className: 'svg',
	      dangerouslySetInnerHTML: { __html: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" baseProfile="full" width="24" height="24" viewBox="0 0 24.00 24.00" enable-background="new 0 0 24.00 24.00" xml:space="preserve">' + '<path d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"></path>' + '</svg>' } }),
	    props.name
	  );
	}
	
	(0, _reactDom.render)(_react2.default.createElement(Demo1, null), document.getElementById('demo1'));
	(0, _reactDom.render)(_react2.default.createElement(Demo2, null), document.getElementById('demo2'));
	(0, _reactDom.render)(_react2.default.createElement(Demo3, null), document.getElementById('demo3'));

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(74);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FileView = __webpack_require__(139);
	
	var _FileView2 = _interopRequireDefault(_FileView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FolderView = function (_Component) {
	  _inherits(FolderView, _Component);
	
	  function FolderView(props) {
	    _classCallCheck(this, FolderView);
	
	    var _this = _possibleConstructorReturn(this, (FolderView.__proto__ || Object.getPrototypeOf(FolderView)).call(this, props));
	
	    _this.state = {
	      open: props.expended || false
	    };
	    return _this;
	  }
	
	  _createClass(FolderView, [{
	    key: 'toggleFolder',
	    value: function toggleFolder() {
	      var _this2 = this;
	
	      var open = this.state.open;
	      var _props = this.props,
	          name = _props.name,
	          parentPath = _props.parentPath,
	          folderObj = _props.folderObj;
	
	      var currentPath = parentPath + '/' + name;
	
	      this.setState({ open: !open }, function () {
	        var fn = _this2.props.folderClickHandler;
	        fn && fn(name, currentPath, folderObj);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          level = _props2.level,
	          name = _props2.name,
	          parentPath = _props2.parentPath,
	          folderObj = _props2.folderObj,
	          maxFolderLevel = _props2.maxFolderLevel,
	          expended = _props2.expended,
	          folderTemplate = _props2.folderTemplate,
	          fileTemplate = _props2.fileTemplate,
	          fileClassName = _props2.fileClassName,
	          folderClassName = _props2.folderClassName,
	          fileClickHandler = _props2.fileClickHandler,
	          selectedFilePath = _props2.selectedFilePath,
	          folderClickHandler = _props2.folderClickHandler;
	      var open = this.state.open;
	
	      var styl = open ? { 'display': 'block' } : { 'display': 'none' };
	      var cns = (folderClassName || '') + ' subFolder';
	      var passedFolderProps = {
	        maxFolderLevel: maxFolderLevel,
	        expended: expended,
	        folderTemplate: folderTemplate,
	        fileTemplate: fileTemplate,
	        fileClickHandler: fileClickHandler,
	        fileClassName: fileClassName,
	        folderClassName: folderClassName,
	        selectedFilePath: selectedFilePath,
	        folderClickHandler: folderClickHandler
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { key: 'folder-' + name, className: open ? 'open ' + cns : cns },
	        folderTemplate && folderTemplate({
	          name: name,
	          folderObj: folderObj,
	          currentPath: parentPath + '/' + name,
	          onclick: this.toggleFolder.bind(this)
	        }) || _react2.default.createElement(
	          'a',
	          { onClick: this.toggleFolder.bind(this) },
	          '/',
	          name
	        ),
	        _react2.default.createElement(
	          'ul',
	          { style: styl, 'data-level': level },
	          folderObj && folderObj['_contents'].map(function (f) {
	            return _react2.default.createElement(_FileView2.default, {
	              key: 'file-' + f.path,
	              file: f,
	              fileTemplate: fileTemplate,
	              fileClickHandler: fileClickHandler,
	              fileClassName: fileClassName,
	              selectedFilePath: selectedFilePath });
	          }),
	          parseInt(maxFolderLevel) && maxFolderLevel > level || isNaN(parseInt(maxFolderLevel)) ? folderObj && Object.keys(folderObj).filter(function (k) {
	            return k !== '_contents';
	          }).map(function (prop) {
	            return _react2.default.createElement(FolderView, _extends({
	              key: 'folder-' + name + '-' + prop,
	              level: level + 1,
	              name: prop,
	              parentPath: parentPath + '/' + name,
	              folderObj: folderObj[prop]
	            }, passedFolderProps));
	          }) : _react2.default.createElement(
	            'span',
	            { className: 'more' },
	            '...'
	          )
	        )
	      );
	    }
	  }]);
	
	  return FolderView;
	}(_react.Component);
	
	exports.default = FolderView;

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(74);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FileView = __webpack_require__(139);
	
	var _FileView2 = _interopRequireDefault(_FileView);
	
	var _FolderView = __webpack_require__(202);
	
	var _FolderView2 = _interopRequireDefault(_FolderView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NestedFileTreeView(props) {
	  var directory = props.directory,
	      maxFolderLevel = props.maxFolderLevel,
	      expended = props.expended,
	      className = props.className,
	      fileClickHandler = props.fileClickHandler,
	      folderClickHandler = props.folderClickHandler,
	      fileClassName = props.fileClassName,
	      folderClassName = props.folderClassName,
	      selectedFilePath = props.selectedFilePath,
	      selectedClassName = props.selectedClassName,
	      fileTemplate = props.fileTemplate,
	      folderTemplate = props.folderTemplate;
	
	
	  var passedProps = {
	    fileClickHandler: fileClickHandler,
	    fileClassName: fileClassName,
	    folderClassName: folderClassName,
	    selectedFilePath: selectedFilePath,
	    selectedClassName: selectedClassName,
	    fileTemplate: fileTemplate
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { 'data-level': '0', className: className },
	    directory && directory['_contents'].map(function (file) {
	      return _react2.default.createElement(_FileView2.default, _extends({
	        key: 'root-file-' + file.path,
	        file: file
	      }, passedProps));
	    }),
	    directory && Object.keys(directory).filter(function (k) {
	      return k !== '_contents';
	    }).map(function (prop) {
	      return _react2.default.createElement(_FolderView2.default, _extends({
	        key: 'root-folder-' + prop,
	        level: 1,
	        expended: expended,
	        maxFolderLevel: maxFolderLevel,
	        folderObj: directory[prop],
	        name: prop,
	        parentPath: '',
	        folderClickHandler: folderClickHandler,
	        folderTemplate: folderTemplate
	      }, passedProps));
	    })
	  );
	}
	
	NestedFileTreeView.propTypes = {
	  directory: _react.PropTypes.object.isRequired,
	  maxFolderLevel: _react.PropTypes.number,
	  expended: _react.PropTypes.bool,
	  className: _react.PropTypes.string,
	  fileClickHandler: _react.PropTypes.func,
	  folderClickHandler: _react.PropTypes.func,
	  fileClassName: _react.PropTypes.string,
	  folderClassName: _react.PropTypes.string,
	  selectedFilePath: _react.PropTypes.string,
	  selectedClassName: _react.PropTypes.string,
	  folderTemplate: _react.PropTypes.func,
	  fileTemplate: _react.PropTypes.func
	};
	
	exports.default = NestedFileTreeView;

/***/ },

/***/ 385:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(386)();
	// imports
	
	
	// module
	exports.push([module.id, "li,ul{margin:0;padding:0}ul{list-style:none;margin:0}ul a{border-radius:2px;border-left:4px solid transparent;display:block;color:inherit;margin-bottom:3px;padding:3px;cursor:pointer;text-decoration:none}ul a:hover{background:#eee}li ul{margin-left:18px}.active{background:#0a93ff}*{box-sizing:border-box}body{font-size:16px;color:#4e4e4e}h2{font-size:1.4em}.container{min-width:40em;max-width:80em;width:100%;margin:auto;padding:0 1em}svg{display:inline-block;float:left;fill:#aaa;height:18px;margin-top:2px;width:18px}pre{white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word;margin:0}.code,.demo{display:inline-block;width:100%;vertical-align:top}.code{border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;background-color:#f9f9f9}@media (min-width:60em){.code{margin-left:2%;width:58%}}@media (min-width:60em){.demo{width:38%}}", ""]);
	
	// exports


/***/ },

/***/ 386:
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ 484:
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ 485:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(484)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./../node_modules/stylus-loader/index.js!./main.styl", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./../node_modules/stylus-loader/index.js!./main.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }

});


// WEBPACK FOOTER //
// app.js